'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('\\', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/remark-parse/lib/locate/escape.js
// module id = 592
// module chunks = 0 15 16 17 18